<template>
    <div class="custom_modal_cnt">
        <div class="modal_title">      
            <h2> Job Details  </h2>                
                <span class="close--" @click="hideMe()"><x-icon size="1.5x"></x-icon></span>
        </div>
            <div>
            <div class="custom-tabs">
                <ul class="d-flex">
                    <!-- <li :class="{'active':activeTab=='jobDetails'}" @click="tabChanged('jobDetails')">Job Information</li>
                    <li  :class="{'active':activeTab=='wageInfo'}" @click="tabChanged('wageInfo')">Wage Information</li> -->
                    <li  :class="{'active':activeTab=='jobOpptInfo'}" @click="tabChanged('jobOpptInfo')">Job Opportunity Information</li>
                    <li  :class="{'active':activeTab=='attornyOrAgentInfo'}" @click="tabChanged('attornyOrAgentInfo')">Attorney or Agent Information</li>
                </ul>
            </div>
                <div v-if="petitionDetails">
                        <div v-if="activeTab=='jobDetails'">
                            <div class="modal_cnt withTabButtons">
                                <form data-vv-scope="jobDetails" @submit.prevent="" @keydown.enter.prevent="" >
                                    <div @click="jdUpdateStatusError=''" class="form-container">
                                        <VuePerfectScrollbar	
                                            ref="mainSidebarPs"	
                                            class="scroll-area--main-sidebar"	
                                            :settings="settings"	
                                        >
                                        <div class="infoSec">
                                            <div class="vx-row" > 
                                                <template v-if="false">
                                                    <immiInput :wrapclass="'md:w-1/3'" :display="true" :cid="'jobTitle'" :formscope="'jobDetails'"  v-model="petitionDetails['jobDetails'].jobTitle" :required="true" fieldName="jobTitle" label="Job Title" placeHolder="Job Title"   />
                                                    <selectField :wrapclass="'md:w-1/3'" :required="true"  cid="preferredSocCode"  :formscope="'jobDetails'" :optionslist="masterSocList" v-model="petitionDetails['jobDetails'].preferredSocCodeDetails" @input="petitionDetails['jobDetails'].preferredSocCode = petitionDetails['jobDetails'].preferredSocCodeDetails['id']"   fieldName="preferredSocCode" label="Preferred SOC Code" placeHolder="Preferred SOC Code "   />  
                                                    <immiInput :wrapclass="'md:w-1/3'" :display="true" :cid="'preferredSocOccuTitle'" :formscope="'jobDetails'" v-model="petitionDetails['jobDetails'].preferredSocOccuTitle"   :required="true" fieldName="preferredSocOccuTitle" label="Preferred SOC Title" placeHolder="Preferred SOC Title" />
                                                    <selectField :wrapclass="'md:w-1/3'" :required="true"  cid="socCode"  :formscope="'jobDetails'" :optionslist="masterSocList" v-model="petitionDetails['jobDetails'].socCodeDetails" @input="petitionDetails['jobDetails'].socCode = petitionDetails['jobDetails'].socCodeDetails['id']"   fieldName="socCod" label="SOC Code" placeHolder="SOC Code "   />  
                                                    <immiInput :wrapclass="'md:w-1/3'" :display="true" :cid="'socOccuTitle'" :formscope="'jobDetails'" v-model="petitionDetails['jobDetails'].socOccuTitle"   :required="true" fieldName="socOccuTitle" label="SOC Title" placeHolder="SOC Title" />
                                                    <selectField :listContainsId="false" :display="true" :wrapclass="'md:w-1/3'" :formscope="'jobDetails'" :required="true"  cid="classification"   :optionslist="classificationList" v-model="petitionDetails['jobDetails'].classification" label="Classification"  fieldName="classification" placeHolder="Classification"   /> 
                                                    <selectField :wrapclass="'md:w-1/3'" :required="true" :optionslist="educationTypes" v-model="petitionDetails['jobDetails'].minDegreeDetails" @input="petitionDetails['jobDetails'].minDegree = petitionDetails['jobDetails'].minDegreeDetails['id']" :formscope="'jobDetails'"  fieldName="minDegree" label="Minimum Education Level" placeHolder="Minimum Education Level"   />  
                                                    <immiInput :wrapclass="'md:w-1/3'" :display="true" :cid="'majorFieldsOfStudy'" :formscope="'jobDetails'" v-model="petitionDetails['jobDetails'].majorFieldsOfStudy"   :required="true" fieldName="majorFieldsOfStudy" label="Major Field of Study" placeHolder="Major Field of Study" />
                                                    <immiInput :onlyNumbers="true" :allowFloatingPoint="true" :wrapclass="'md:w-1/3'" :display="true" cid="expInYears" :formscope="'jobDetails'"  v-model="petitionDetails['jobDetails'].expInYears" :required="true" fieldName="expInYears" label="Experience in Years" placeHolder="Experience"  :maxLength="5" />
                                                    <immiInput :onlyNumbers="true" :allowFloatingPoint="true" :wrapclass="'md:w-1/3'" :display="true" cid="wageRate" :formscope="'jobDetails'" v-model="petitionDetails['jobDetails'].wageRate" :required="true" fieldName="wageRate" label="Preferred Wage Rate" placeHolder="Preferred Wage Rate" :maxLength="10" />
                                                <template >
                                                <div class="vx-col w-full">
                                                    <div class="skilladdsec">
                                                        <label>Specific skills or other requirements </label>
                                                        <ul>
                                                            <li v-for="(skil , index ) in petitionDetails['jobDetails']['skills']" :key="index">
                                                                <span class="skill-label">{{skil}}</span>
                                                            

                                                                <span  @click="removeSkill(index)" class="row_btn">
                                                                    <img src="@/assets/images/main/delete-row-img.svg">
                                                                </span>
                                                            </li>
                                                        </ul>
                                                        <div class="add-input-sec">
                                                            <div @keyup.enter.native="addNewSkill()" @keyup="addSkill=true">
                                                                <immiInput  :wrapclass="'w-full'"  :display="true" cid="addSkill" :formscope="'jobOpptInfo'"  v-model="newSkill" :required="false" fieldName="altAcceptExpInYears" placeHolder=""  />
                                                                <span v-if="addSkill"  @click="addNewSkill()" class="add-more">Add</span>
                                                            </div>

                                                            <!-- <li v-if="!addSkill"  @click="newSkill =''" > <span class="add-more">+ More</span></li> -->
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                </template> 
                                                <immitextfield  wrapclass="md:w-1/1"  :formscope="'jobDetails'"  v-model="petitionDetails['jobDetails'].description" :required="true" fieldName="description" label="Job Description" placeHolder="Job Description"></immitextfield>
                                                <div class="vx-col w-full" v-if="countries.length>0"    vs-type="flex"  vs-justify="center" vs-align="center" vs-lg=" "  vs-sm=" "  >
                                                <div class="addMoreAddress">
                                                    
                                                <h3 class="small-header mt-0">Primary Worksite </h3>
                                                <template v-for="(addr ,addind ) in petitionDetails['jobDetails']['workAddresses']" >
                                                    <div class="vx-row mar0" :key="addind"  >
                                                            <addressFields
                                                                :formscope="'jobOpptInfo'"
                                                                :key="addind"
                                                                :name="'PrimaryWork_Location'+addind"
                                                                :disableCountry="true"
                                                                :addFormContainerCls="false"
                                                                :validationRequired="true"
                                                                :showaptType="true"
                                                                :countries="countries"
                                                                v-model="petitionDetails['jobDetails']['workAddresses'][addind]"
                                                                :cid="'Primary_Work_Location'+addind"
                                                            />
                                                        </div>
                                                </template>
                                                </div>    
                                                </div>
                                            <div class="divider mt-0"></div>
                                                </template>
                                                <template>
                                                    <immiInput :wrapclass="'md:w-1/3'" :display="true" :cid="'jobId'" :formscope="'jobDetails'"  v-model="petitionDetails['moreJobDetails'].jobId" :required="false" fieldName="jobId" label="Job ID" placeHolder="Job ID"   />
                                                    <immiInput v-if="!checkProperty( this.petitionDetails , 'noOfPositions')" :onlyNumbers="true" :allowFloatingPoint="false" :wrapclass="'md:w-1/3'" :display="true" :cid="'noOfPositionss'" :formscope="'jobDetails'" v-model="petitionDetails['moreJobDetails'].noOfPositions" :maxLength="4"  :required="true" fieldName="noOfPositions" label="No of Positions" placeHolder="No of Positions" />
                                                    <immiInput :onlyNumbers="true" :wrapclass="'md:w-1/3'" :display="true" cid="salary" :formscope="'jobDetails'"  v-model="petitionDetails['moreJobDetails'].salary" :required="true" fieldName="salary" label="Salary per Year" placeHolder="Salary"   />                                   
                                                    <selectField :listContainsId="false" :wrapclass="'md:w-1/3'" cid="jobType"  :required="true" :optionslist="['Full Time', 'Part Time']" v-model="petitionDetails['moreJobDetails'].jobType" :formscope="'jobDetails'"  fieldName="jobType"  label="Job Type" placeHolder="Job Type"  />                                     
                                                    <selectField :listContainsId="false" :wrapclass="'md:w-1/3'" cid="jobShift"  :required="true" :optionslist="['Day', 'Night']" v-model="petitionDetails['moreJobDetails'].jobShift" :formscope="'jobDetails'"  fieldName="jobShift"  label="Job Shift" placeHolder="Job Shift"   />                                     
                                                    <immiInput :maxvalueData="'maxval:168'" :ref="'updateHoursPerWeek'" :allowFloatingPoint="false" :onlyNumbers="true" @input="updateHoursWeek($event)" :wrapclass="'md:w-1/3'" :display="true" cid="hoursPerWeek" :formscope="'jobDetails'"  v-model="petitionDetails['moreJobDetails'].hoursPerWeek" :required="true" fieldName="hoursPerWeek" label="Hours per Week" placeHolder="Hours per Week"  :maxLength="3" />
                                                    <!-- <immiInput  :wrapclass="'md:w-1/3'" :display="true" cid="applyByMail" :formscope="'jobDetails'"  v-model="petitionDetails['moreJobDetails'].applicationInfo.applyByMail" :required="true" fieldName="applyByMail" label="Apply By Mail" placeHolder="Apply By Mail"   /> -->
                                                    <immitextarea  wrapclass="md:w-1/1"  :formscope="'jobDetails'" v-model="petitionDetails['moreJobDetails'].applicationInfo.applyByMail" :required="true" fieldName="applyByMail" label="Mailing Address to post job application" placeHolder="Mailing Address to post job application"></immitextarea>
                                                    <!----:dateEnableTo="new Date()"-->
                                                    <datepickerField wrapclass="md:w-1/3" @input="updateJobStartDate($event)"    :display="true"  v-model="petitionDetails['moreJobDetails'].applicationInfo.jobStartsOn" :formscope="'jobDetails'"  fieldName="jobStartsOn"  label="Job Start Date" :validationRequired="true"   />
                                                    <datepickerField wrapclass="md:w-1/3" :isDisabled="!petitionDetails['moreJobDetails'].applicationInfo.jobStartsOn" :dateOpenFrom="petitionDetails['moreJobDetails'].applicationInfo.jobStartsOn"  :display="true"   v-model="petitionDetails['moreJobDetails'].applicationInfo.jobEndOn" :formscope="'jobDetails'"  fieldName="jobEndOn" :dateEnableFrom="petitionDetails['moreJobDetails'].applicationInfo.jobStartsOn"  label="Job End Date"  :validationRequired="true"   />
                            



                                                    <!-- <selectField :wrapclass="'md:w-1/3'" :required="true" :optionslist="educationTypes" v-model="petitionDetails['jobDetails'].minDegreeDetails" @input="updateMainDegree" :formscope="'jobDetails'"  fieldName="minDegree" label="Minimum Education Level" placeHolder="Minimum Education Level"   />  
                                                    <immiInput :onlyNumbers="true" :allowFloatingPoint="true" :wrapclass="'md:w-1/3'" :display="true" cid="expInYears" :formscope="'jobDetails'"  v-model="petitionDetails['jobDetails'].expInYears" :required="true" fieldName="expInYears" label="Experience in Years" placeHolder="Experience"  :maxLength="5" /> -->
                                                </template> 
                                            </div>
                                            <div @click="jdUpdateStatusError=''" class="text-danger text-sm formerrors" v-if="jdUpdateStatusError!=''"> 
                                                <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal" icon="IP-information-button" active="true">{{ jdUpdateStatusError }}</vs-alert>
                                            </div>
                                        </div> 
                                    </VuePerfectScrollbar>

                                    </div>
                                </form>
                            </div>
                            <div class="popup-footer">
                                    <span class="loader" v-if="jdUpdating"><img src="@/assets/images/main/loader.gif"></span>
                                    <vs-button color="dark" class="cancel" type="filled" @click="hideMe()">Cancel</vs-button>
                                    <vs-button color="success" :disabled="jdUpdating" @click="tabChanged('wageInfo')" class="save" type="filled">Next</vs-button>
                                    
                                    
                                   
                                   
                                    </div>

                        </div>
                        <div v-if="activeTab=='wageInfo'">
                            <div class="modal_cnt withTabButtons">
                                <form data-vv-scope="wageInfo" @submit.prevent="" @keydown.enter.prevent="" >
                                <div @click="jdUpdateStatusError='';"  class="form-container">
                                    <VuePerfectScrollbar	
                                                ref="mainSidebarPs"	
                                                class="scroll-area--main-sidebar"	
                                                :settings="settings"	
                                            
                                            > 
                                    <div class="infoSec">
                                        <h4>Wage Information</h4>
                                        <div class="vx-row">
                                            <immiInput v-if="false" :wrapclass="'md:w-1/3'" :display="true" cid="trackingNumber" :formscope="'wageInfo'" v-model="petitionDetails.wageInfo.trackingNumber" :required="true" fieldName="trackingNumber" label="Tracking Number" placeHolder="Tracking Number" />
                                            <selectField :wrapclass="'md:w-1/3'" :required="true"  cid="preferredSocCode"  :formscope="'wageInfo'" :optionslist="masterSocList" v-model="petitionDetails.wageInfo.preferredSocCodeDetails" @input="petitionDetails.wageInfo.preferredSocCode = petitionDetails.wageInfo.preferredSocCodeDetails['id']"   fieldName="preferredSocCode" label="Preferred SOC Code" placeHolder="Preferred SOC Code "   />  
                                            <immiInput :onlyNumbers="true" :allowFloatingPoint="true" :wrapclass="'md:w-1/3'" :display="true" cid="preferredWageRate" :formscope="'wageInfo'" v-model="petitionDetails.wageInfo.preferredWageRate" :required="true" fieldName="preferredWageRate" label="Preferred Wage Rate" placeHolder="Preferred Wage Rate" :maxLength="10" />
                                            <selectField :listContainsId="false" :wrapclass="'md:w-1/3'" :required="true"  :formscope="'wageInfo'" cid="offerpayFrequency"  :optionslist="payFrequencyList" v-model="petitionDetails.wageInfo.payFrequency"  fieldName="offerpayFrequency" label="Pay Frequency" placeHolder="Pay Frequency"   />  
                                            <selectField :listContainsId="false" :wrapclass="'md:w-1/3'" :required="true" :formscope="'wageInfo'" cid="wageSource"  :optionslist="wageSourceList" v-model="petitionDetails.wageInfo.wageSource"   fieldName="wageSource" label="Source of Wage" placeHolder="Source of Wage"   />  
                                            <datepickerField wrapclass="md:w-1/3" :dateEnableTo="new Date()" @input="updateDeterminationDate($event)" :display="true"  v-model="petitionDetails.wageInfo.determinationDate" :formscope="'wageInfo'" fieldName="determinationDate"  label="Determination Date" :validationRequired="true" />
                                            <datepickerField :isDisabled="!petitionDetails.wageInfo.determinationDate" wrapclass="md:w-1/3"  :display="true"   v-model="petitionDetails.wageInfo.expirationDate" :formscope="'wageInfo'" fieldName="expirationDate" :dateEnableFrom="petitionDetails.wageInfo.determinationDate" label="Expiration Date"  :validationRequired="true" />
                                            <immitextarea v-if="checkProperty(petitionDetails,'wageInfo','wageSource') == 'Other'"  wrapclass="md:w-1/1"  :formscope="'wageInfo'" v-model="petitionDetails.wageInfo.wageSourceOtherDesc" :required="true" fieldName="wageSourceOtherDesc" label="Wage Source Description" placeHolder="Wage Source Description"></immitextarea>

                                        </div>
                                    <div class="divider mt-0"></div>
                                    <h4>Wage Offer Information</h4>
                                        <div class="vx-row">
                                        <div class="vx-col  w-full md:w-1/3" >
                                             <div class="form_group">
                                                   <label class="form_label">Minimum Wage<em >*</em></label>
                                                   <vs-input  :key="'wageminimum'" oninput="petitionDetails.wageOfferInfo.minWage = petitionDetails.wageOfferInfo.minWage.replace(/[^0-9 .]/g, '').replace(/(\..*)\./g, '$1'); petitionDetails.wageOfferInfo.minWage = petitionDetails.wageOfferInfo.minWage.replace(/ /g,'')"  name="wageminimum" v-model="petitionDetails.wageOfferInfo.minWage" v-validate="'required|numeric' "  :maxLength="9" class="w-full" :data-vv-as="'Minimum Wage'"  />
                                                   <p v-show="errors.has('wageInfo.wageminimum')" class="text-danger text-sm">{{ errors.first('wageInfo.wageminimum') }}</p>
                                                </div>
                                         </div>
                                         <div class="vx-col  w-full md:w-1/3" >
                                             <div class="form_group">
                                                   <label class="form_label">Maximum Wage<em >*</em></label>
                                                   <vs-input :key="'MaximumWage'" @input="maxWaseError=''"  oninput="petitionDetails.wageOfferInfo.maxWage = petitionDetails.wageOfferInfo.maxWage.replace(/[^0-9 .]/g, '').replace(/(\..*)\./g, '$1'); petitionDetails.wageOfferInfo.maxWage = petitionDetails.wageOfferInfo.maxWage.replace(/ /g,'');"  name="MaximumWage" v-model="petitionDetails.wageOfferInfo.maxWage" v-validate="'required|numeric' "  :maxLength="9" class="w-full" :data-vv-as="'Maximum Wage'"  />
                                                   
                                                   <p v-if="maxWaseError" class="text-danger text-sm">{{ maxWaseError }}</p>
                                                   <p v-else-if="errors.has('wageInfo.MaximumWage')" class="text-danger text-sm">{{ errors.first('wageInfo.MaximumWage') }}</p>
                                                  
                                                   
                                                </div>
                                         </div>
                                         <div class="vx-col  w-full md:w-1/3" >
                                             <div class="form_group">
                                                   <label class="form_label">Pay Frequency<em >*</em></label>
                                                   <div class="con-select w-full">
                                                    <multiselect  
                                                        name="PayFrequency"
                                                        :multiple="false" 
                                                        v-validate="'required'"
                                                        v-model="petitionDetails.wageOfferInfo.payFrequency" 
                                                        :close-on-select="true"
                                                        data-vv-as="Pay Frequency" 
                                                        placeholder="Pay Frequency"  
                                                        :options="payFrequencyList"
                                                        :searchable="true" 
                                                        :allow-empty="false" 
                                                        >
                                                    </multiselect>
                                                   </div>
                                                   <p v-show="errors.has('wageInfo.PayFrequency')" class="text-danger text-sm">{{ errors.first('wageInfo.PayFrequency') }}</p>
                                                </div>
                                         </div>
                                           
                                            <!-- <selectField :listContainsId="false" :wrapclass="'md:w-1/3'" :required="true"   :formscope="'wageInfo'"  cid="infopayFrequency"  :optionslist="payFrequencyList" v-model="petitionDetails.wageOfferInfo.payFrequency"  fieldName="infopayFrequency" label="Pay Frequency" placeHolder="Pay Frequency"   />   -->
                                            

                                        </div>
                                            <div @click="jdUpdateStatusError=''" class="text-danger text-sm formerrors" v-if="jdUpdateStatusError!=''">
                                            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal" icon="IP-information-button" active="true">{{ jdUpdateStatusError }}</vs-alert>
                                            </div>  
                                    </div>
                                    </VuePerfectScrollbar>
                                </div>
                                
                                
                                </form>
                            </div>
                            <div class="popup-footer">
                                <span class="loader" v-if="jdUpdating"><img src="@/assets/images/main/loader.gif"></span>
                                <vs-button color="dark" class="cancel" type="filled" @click="hideMe()">Cancel</vs-button>
                                <vs-button color="dark" class="save" type="filled" :disabled="jdUpdating" @click="tabChanged('jobDetails', true)" >Back</vs-button>                                
                                <vs-button color="dark" class="save" type="filled" :disabled="jdUpdating" @click="tabChanged('jobOpptInfo', false)" >Next</vs-button>
                                
                               
                                <!-----
                                     <vs-button color="success" :disabled="jdUpdating" @click="submitForm()" class="save" type="filled">Submit</vs-button>
                                --->
                            </div>
                        </div>
                        <div v-if="activeTab=='jobOpptInfo'">
                            
                            <div class="modal_cnt withTabButtons">
                                <form @click="jdUpdateStatusError=''"  data-vv-scope="jobOpptInfo" @submit.prevent="" @keydown.enter.prevent="" >
                                <div class="form-container">
                                    <VuePerfectScrollbar	
                                            ref="mainSidebarPs"	
                                            class="scroll-area--main-sidebar"	
                                            :settings="settings"	
                                        
                                        > 
                                        <div class="infoSec">
                                            <div class="vx-row">
                                              
                                            <!-- <div class="vx-col  w-full md:w-1/3" >
                                                  <div class="form_group">
                                                   <label class="form_label">Preferred Job Title<em >*</em></label>
                                                   <vs-input  :key="'jobTitle'" name="jobTitle" v-model="petitionDetails.jobOpportunityInfo.jobTitle" v-validate="'required' "  class="w-full" :data-vv-as="'Preferred Job Title'"  />
                                                   <p v-show="errors.has('jobOpptInfo.jobTitle')" class="text-danger text-sm">{{ errors.first('jobOpptInfo.jobTitle') }}</p>
                                                </div>
                                            </div>  -->
                                            
 
                                            <!-- <div class="vx-col  w-full md:w-1/3" >
                                                  <div class="form_group">
                                                   <label class="form_label">Major Field of Study<em >*</em></label>
                                                   <vs-input :key="'majorFieldsOfStudy'"  name="majorFieldsOfStudy" v-model="petitionDetails.jobOpportunityInfo.majorFieldsOfStudy" v-validate="'required' "  class="w-full" :data-vv-as="'Major Field of Study'"  />
                                                   <p v-show="errors.has('jobOpptInfo.majorFieldsOfStudy')" class="text-danger text-sm">{{ errors.first('jobOpptInfo.majorFieldsOfStudy') }}</p>
                                                </div>
                                            </div> -->
                                            
                                            <redioButtons   :wrapclass="''" :cid="'isTrainigRequired'" @input="updateIsTrainigRequired" :formscope="'jobOpptInfo'" v-model="petitionDetails.jobOpportunityInfo.isTrainigRequired" fieldName="isTrainigRequired" label="Is training for the job opportunity required?" placeHolder="" />
                                            <immiInput v-if="checkProperty(petitionDetails ,'jobOpportunityInfo','isTrainigRequired')=='Yes'" :onlyNumbers="true" :wrapclass="'md:w-1/2'" :display="true" cid="noOfTraningMonths" :formscope="'jobOpptInfo'" v-model="petitionDetails.jobOpportunityInfo.noOfTraningMonths" :required="true" fieldName="noOfTraningMonths" label="No of months training required" placeHolder="No of months training" :maxLength="3"  />
                                            <immiInput v-if="checkProperty(petitionDetails ,'jobOpportunityInfo','isTrainigRequired')=='Yes'" :wrapclass="'md:w-1/2'" :display="true" cid="fieldOfTraining" :formscope="'jobOpptInfo'" v-model="petitionDetails.jobOpportunityInfo.fieldOfTraining" :required="true" fieldName="fieldOfTraining" label="Indicate the field of training" placeHolder="Indicate the field of training"  />
                                            
                                            
                                            <redioButtons  :wrapclass="''" :cid="'isExpRequired'" @input="updateisExpRequired" formscope="jobOpptInfo" v-model="petitionDetails.jobOpportunityInfo.isExpRequired" fieldName="isExpRequired" label="Is employment experience required?" placeHolder="" />
                                            <immiInput v-if="checkProperty(petitionDetails ,'jobOpportunityInfo','isExpRequired')=='Yes'" :onlyNumbers="true" :wrapclass="'md:w-1/2'" :display="true" cid="noOfExpMonths" :formscope="'jobOpptInfo'" v-model="petitionDetails.jobOpportunityInfo.noOfExpMonths" :required="true" fieldName="noOfTraningMonths" label="No of months of experience required" placeHolder="No of months of experience " :maxLength="3"  />
                                            <immiInput v-if="checkProperty(petitionDetails ,'jobOpportunityInfo','isExpRequired')=='Yes'" :wrapclass="'md:w-1/2'" :display="true" cid="expReqOccupation" :formscope="'jobOpptInfo'" v-model="petitionDetails.jobOpportunityInfo.expReqOccupation" :required="true" fieldName="expReqOccupation" label="Indicate the occupation required" placeHolder="Indicate the occupation required"  />


                                            <redioButtons  :wrapclass="''" :cid="'isAltFieldOfStudyAccept'" @input="updateisAltFieldOfStudyAccept" formscope="jobOpptInfo" v-model="petitionDetails.jobOpportunityInfo.isAltFieldOfStudyAccept" fieldName="isAltFieldOfStudyAccept" label="Does the employer require a second U.S. diploma/degree?" placeHolder="" />
                                            <immiInput v-if="checkProperty(petitionDetails ,'jobOpportunityInfo','isAltFieldOfStudyAccept')=='Yes'"  :wrapclass="'md:w-1/2'" :display="true" cid="altMajorFieldOfStudy" :formscope="'jobOpptInfo'" v-model="petitionDetails.jobOpportunityInfo.altMajorFieldOfStudy" :required="true" fieldName="altMajorFieldOfStudy" label="Specify alternate field of study" placeHolder="Specify alternate of study"  />
                                            
                                            <redioButtons  :wrapclass="''" :cid="'splSkillOrOtherRequi'" @input="updatedSplSkillOrOtherRequi" formscope="jobOpptInfo" v-model="petitionDetails.jobOpportunityInfo.splSkillOrOtherRequi" fieldName="splSkillOrOtherRequi" label="Does the employer require any specific or other requirements?" placeHolder="" />
                                               
                                            <template v-if="checkProperty(petitionDetails,'jobOpportunityInfo','splSkillOrOtherRequi')=='Yes'">
                                                <immiInput :wrapclass="'md:w-1/2'" :display="true" :cid="'ForeignLanguage'" formscope="jobOpptInfo"  v-model="petitionDetails.jobOpportunityInfo.ForeignLanguage"             :required="toggleRequired['ForeignLanguage']" @input="checkisRequirement()" fieldName="Foreign language" label="Foreign language" placeHolder="Foreign language"   />
                                                <immiInput :wrapclass="'md:w-1/2'" :display="true" :cid="'License/Certification'" formscope="jobOpptInfo"  v-model="petitionDetails.jobOpportunityInfo.LicenseCertification"  :required="toggleRequired['LicenseCertification']"  @input="checkisRequirement()" fieldName="License/Certification" label="License/Certification" placeHolder="License/Certification"   />
                                                <immiInput :wrapclass="'md:w-1/2'" :display="true" :cid="'residencyFellowship'" formscope="jobOpptInfo"  v-model="petitionDetails.jobOpportunityInfo.residencyFellowship" :required="toggleRequired['residencyFellowship']" @input="checkisRequirement()" fieldName="residencyFellowship" label="Residency/Fellowship" placeHolder="Residency/Fellowship"   />
                                                <immiInput :wrapclass="'md:w-1/2'" :display="true" :cid="'otherSplSkillsOrRequi'" formscope="jobOpptInfo"  v-model="petitionDetails.jobOpportunityInfo.otherSplSkillsOrRequi" :required="toggleRequired['otherSplSkillsOrRequi']"  @input="checkisRequirement()" fieldName="otherSplSkillsOrRequi" label="Other Special Skills or Requirements" placeHolder="Other Special Skills or Requirements"   />
                                                </template>




                                            <!-- <redioButtons  :wrapclass="''" :cid="'isAltCombOfEduAndExpAccept'" @input="updateisAltCombOfEduAndExpAccept" formscope="jobOpptInfo" v-model="petitionDetails.jobOpportunityInfo.isAltCombOfEduAndExpAccept" fieldName="isAltCombOfEduAndExpAccept" label="Is there an alternate combination of education and experience that is acceptable?" placeHolder="" />
                                            <selectField v-if="checkProperty(petitionDetails ,'jobOpportunityInfo','isAltCombOfEduAndExpAccept')=='Yes'" :wrapclass="'md:w-1/3'" :required="true" :optionslist="educationTypes" v-model="petitionDetails.jobOpportunityInfo.altLevelOfEduDetails" @input="petitionDetails.jobOpportunityInfo.altLevelOfEdu= checkProperty(petitionDetails.jobOpportunityInfo ,'altLevelOfEduDetails' ,'id')" :formscope="'jobOpptInfo'"  fieldName="altLevelOfEdu" label="Alternate Level of Education" placeHolder="Alternate Level of Education"   />  
                                            
                                            <immiInput v-if="checkProperty(petitionDetails ,'jobOpportunityInfo','isAltCombOfEduAndExpAccept')=='Yes'" :allowFloatingPoint="true" :onlyNumbers="true" :wrapclass="'md:w-1/2'" :display="true" cid="altAcceptExpInYears" :formscope="'jobOpptInfo'" v-model="petitionDetails.jobOpportunityInfo.altAcceptExpInYears" :required="true" fieldName="altAcceptExpInYears" label="Indicate the number of years experience acceptable" placeHolder="No of years experience" :maxLength="5" />
                                             -->

                                            <!-- <redioButtons  :wrapclass="''" :cid="'foreignEduEqAccept'"  formscope="jobOpptInfo" v-model="petitionDetails.jobOpportunityInfo.foreignEduEqAccept" fieldName="foreignEduEqAccept" label="Is a foreign educational equivalent acceptable?" placeHolder="" />
                                            
                                            <redioButtons  :wrapclass="''" :cid="'isExpInAltOccuAccept'" @input="updateisExpInAltOccuAccept" formscope="jobOpptInfo" v-model="petitionDetails.jobOpportunityInfo.isExpInAltOccuAccept" fieldName="isExpInAltOccuAccept" label="Is experience in an alternate occupation acceptable?" placeHolder="" />
                                            <immiInput v-if="checkProperty(petitionDetails ,'jobOpportunityInfo','isExpInAltOccuAccept')=='Yes'" :wrapclass="'md:w-1/2'" :display="true" cid="jobTitleOfAcceptAltOccu" :formscope="'jobOpptInfo'" v-model="petitionDetails.jobOpportunityInfo.jobTitleOfAcceptAltOccu" :required="true" fieldName="jobTitleOfAcceptAltOccu" label="Identify the job title of the acceptable alternate occupation" placeHolder="Job title"  />
                                            <immiInput v-if="checkProperty(petitionDetails ,'jobOpportunityInfo','isExpInAltOccuAccept')=='Yes'" :onlyNumbers="true" :wrapclass="'md:w-1/2'" :display="true" cid="noOfExpMonthsInAltOccu" :formscope="'jobOpptInfo'" v-model="petitionDetails.jobOpportunityInfo.noOfExpMonthsInAltOccu" :required="true" fieldName="noOfExpMonthsInAltOccu" label="No of months experience in alternate occupation required" placeHolder="No of months experience" :maxLength="3"  />
                                        -->
                                            


                                        <!-- // jobDuties: String, // Job duties – If submitting by mail, add attachment if necessary. Job duties description must begin in this space
                                        // jobOppoReqForNormalOccu: String, // Yes/No // Are the job opportunity’s requirements normal for the occupation? -->
                                      
                                      
                                        <!-- <redioButtons :formscope="'jobOpptInfo'" :wrapclass="''" :cid="'jobOppoReqForNormalOccu'"  :showNA="false" formscope="jobOpptInfo" v-model="petitionDetails.jobOpportunityInfo.jobOppoReqForNormalOccu" fieldName="jobOppoReqForNormalOccu" label="Are the job opportunity’s requirements normal for the occupation?" placeHolder="" />                                       -->
                                       

                                        <!-- <div class="vx-col  w-full" >
                                            <div class="form_group">
                                               <label class="form_label">Job Duties<em >*</em></label>
                                                     <ckeditor :editor="editor" :config="editorConfig" :name="'Jobduties'" v-model="petitionDetails.jobOpportunityInfo.jobDuties" v-validate="'required'"  class="w-full" :data-vv-as="'Job Duties'" />
                                                     <p v-show="errors.has('jobOpptInfo.Jobduties')" class="text-danger text-sm">{{ errors.first('jobOpptInfo.Jobduties') }}</p>
                                            </div>
                                         </div> -->



                                        <!-- //   isForiegnLangRequired: String, // Yes/No // Is knowledge of a foreign language required to perform the job duties?
                                    //   skills: Array, // Specific skills or other requirements – If submitting by mail, add attachment if necessary. Skills description must begin in this space.  -->
                                    <!-- <redioButtons  :wrapclass="''" :cid="'isForiegnLangRequired'" @input="updateisForiegnLangRequired" formscope="jobOpptInfo" v-model="petitionDetails.jobOpportunityInfo.isForiegnLangRequired" fieldName="isForiegnLangRequired" label="Is knowledge of a foreign language required to perform the job duties?" placeHolder="" /> -->
                                    <!-- v-if="checkProperty(petitionDetails ,'jobOpportunityInfo','isForiegnLangRequired')=='Yes'" -->
                                    
                                    <!-- <template >
                                        <div class="vx-col w-full">
                                            <div class="skilladdsec">
                                                <label>Specific skills or other requirements </label>
                                                <ul>
                                                    <li v-for="(skil , index ) in petitionDetails['jobOpportunityInfo']['skills']" :key="index">
                                                        <span class="skill-label">{{skil}}</span>
                                                    

                                                        <span  @click="removeSkill(index ,'jobOpportunityInfo')" class="row_btn">
                                                            <img src="@/assets/images/main/delete-row-img.svg">
                                                        </span>
                                                    </li>
                                                </ul>
                                                <div class="add-input-sec">
                                                    <div @keyup.enter.native="addNewSkill('jobOpportunityInfo')" @keyup="addSkill=true">
                                                        <immiInput  :wrapclass="'w-full'"  :display="true" cid="addSkill" :formscope="'jobOpptInfo'"  v-model="newSkill" :required="false" fieldName="altAcceptExpInYears" placeHolder=""  />
                                                        <span v-if="addSkill"  @click="addNewSkill('jobOpportunityInfo')" class="add-more">Add</span>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </template>  -->
                                    
                                    <!-- <redioButtons  :wrapclass="''" :cid="'isApplInvolJobOppoInclCombOfOccu'"  formscope="jobOpptInfo" v-model="petitionDetails.jobOpportunityInfo.isApplInvolJobOppoInclCombOfOccu" fieldName="isApplInvolJobOppoInclCombOfOccu" label="Does this application involve a job opportunity that includes a combination of occupations?" placeHolder="" /> -->
                                    <!-- <redioButtons  :wrapclass="''" :cid="'positionOfferToAlien'"  formscope="jobOpptInfo" v-model="petitionDetails.jobOpportunityInfo.positionOfferToAlien" fieldName="positionOfferToAlien" label="Is the position identified in this application being offered to the alien identified" placeHolder="" /> -->
                                    <!-- <redioButtons  :wrapclass="''" :cid="'alienReqToLiveEmplrPrimisis'"  formscope="jobOpptInfo" v-model="petitionDetails.jobOpportunityInfo.alienReqToLiveEmplrPrimisis" fieldName="alienReqToLiveEmplrPrimisis" label="Does the job require the alien to live on the employer’s premises?" placeHolder="" /> -->
                                    <!-- <redioButtons  :wrapclass="''" :cid="'applLiveInHouseDomWorker'"  formscope="jobOpptInfo" v-model="petitionDetails.jobOpportunityInfo.applLiveInHouseDomWorker" fieldName="applLiveInHouseDomWorker" label="Is the application for a live-in household domestic service worker?" placeHolder="" /> -->
                                    <!-- <redioButtons v-if="checkProperty(petitionDetails['jobOpportunityInfo'],'applLiveInHouseDomWorker')=='Yes'" :wrapclass="''" :cid="'emplrProviedAlienCopyOfContract'"  :showNA="false" formscope="jobOpptInfo" v-model="petitionDetails.jobOpportunityInfo.emplrProviedAlienCopyOfContract" fieldName="emplrProviedAlienCopyOfContract" label="The employer and the alien executed the required employment contract and has the employer provided a copy of the contract to the alien?" placeHolder="" /> -->

                                        </div>
                                        
                                        <div class="divider mt-0"></div>
                                        
                                    <div class="vx-col w-full" v-if="countries.length>0"    vs-type="flex"  vs-justify="center" vs-align="center" vs-lg=" "  vs-sm=" "  >
                                        <div class="addMoreAddress">
                                            
                                        <h3 class="small-header mt-0">Primary Worksite </h3>
                                        <template v-for="(addr ,addind ) in petitionDetails['jobOpportunityInfo']['workAddresses']" >
                                            <div class="vx-row mar0" :key="addind"  >
                                        <!-- <addressFields
                                        
                                                        :formscope="'jobOpptInfo'"
                                                        :name="'PrimaryWork_Location'"
                                                        :disableCountry="true"
                                                        :addFormContainerCls="false"
                                                        :validationRequired="true"
                                                        :showaptType="true"
                                                        :countries="countries"
                                                        v-model="tempAddresses"
                                                        :cid="'Primary_Work_Location'"
                                                    /> -->
                                                    <addressFields
                                                        :formscope="'jobOpptInfo'"
                                                        :key="addind"
                                                        :name="'PrimaryWork_Location'+addind"
                                                        :disableCountry="true"
                                                        :addFormContainerCls="false"
                                                        :validationRequired="true"
                                                        :showaptType="true"
                                                        :countries="countries"
                                                        v-model="petitionDetails['jobOpportunityInfo']['workAddresses'][addind]"
                                                        :cid="'Primary_Work_Location'+addind"
                                                    />
                                                </div>
                                      </template>
                                        <div v-if="false">
                                                <template v-for="(addr ,addind ) in petitionDetails['jobOpportunityInfo']['workAddresses']" >
                                                    <div class="vx-row mar0" :key="addind"  >

                                                    
                                                        <addressFields
                                                        :formscope="'jobOpptInfo'"
                                                        :key="addind"
                                                        :name="'PrimaryWork_Location'+addind"
                                                        :disableCountry="true"
                                                        :addFormContainerCls="false"
                                                        :validationRequired="true"
                                                        :showaptType="true"
                                                        :countries="countries"
                                                        v-model="petitionDetails['jobOpportunityInfo']['workAddresses'][addind]"
                                                        :cid="'Primary_Work_Location'+addind"
                                                    />
                                                    <template >
                                                    <div class="vx-col w-full pad0">
                                                        <div class="form_group custom-radio_wrap">
                                                        <h6>Is this Work Location address?</h6>
                                                        <ul class="custom-radio" vs-type="flex" vs-align="center">
                                                            <li>
                                                            <vs-radio
                                                                @change="setWorkLocation(addind)"
                                                                :vs-name="'workLocation'+addind"
                                                                v-model="addr.workLocation"
                                                                :vs-value="true"
                                                            >Yes</vs-radio>
                                                            </li>
                                                            <li>
                                                            <vs-radio
                                                            :vs-name="'workLocation'+addind"
                                                                
                                                                v-model="addr.workLocation"
                                                                :vs-value="false"
                                                            >No</vs-radio>
                                                            </li>
                                                        </ul>
                                                        </div>
                                                    </div>
                                                    <div class="vx-col w-full p-0" v-if="false">
                                                        <div class="form_group">
                                                            <label class="form_label">Work Location/Company Name</label>
                                                        <vs-input 
                                                            class="w-full"
                                                        
                                                            data-vv-as="Work Location/Company Name"
                                                            :name="'workAddressCompanyName'+addind"
                                                            v-model="addr.companyName" 
                                                        />
                                                        <span
                                                            class="text-danger text-sm"
                                                            v-show="errors.has('workAddressCompanyName')"
                                                        >{{ errors.first("workAddressCompanyName") }}</span>
                                                        </div>
                                                    </div>
                                                </template>
                                                    <span v-if="petitionDetails['jobOpportunityInfo']['workAddresses'].length>1"  @click="removeAddress(addind)" class="row_btn">
                                                        <img src="@/assets/images/main/delete-row-img.svg">
                                                    </span>
                                                    <div v-if="petitionDetails['jobOpportunityInfo']['workAddresses'].length>1 && addind !=(petitionDetails['jobOpportunityInfo']['workAddresses'].length)-1" class="divider full-divider mb-10"></div>
                                                    </div>
                                                

                                                </template>
                                            <div class="vx-row mar0" >
                                            <span @click="addAddress()" class="add-more">+ More</span>
                                            </div>
                                         </div> 
                                        </div>    
                                    </div>
                                    <div @click="jdUpdateStatusError=''" class="text-danger text-sm formerrors mt-5" v-if="jdUpdateStatusError!=''">
                                    <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal" icon="IP-information-button" active="true">{{ jdUpdateStatusError }} </vs-alert>
                                </div>
                                       </div>
                                    </VuePerfectScrollbar>
                                </div>
                                

                                
                            </form>
                            </div>
                            <div class="popup-footer">
                                <span class="loader" v-if="jdUpdating"><img src="@/assets/images/main/loader.gif"></span>
                                <vs-button color="dark" class="cancel" type="filled" @click="hideMe()">Cancel</vs-button>
                                
                                <!-- <vs-button color="dark" class="save" type="filled" :disabled="jdUpdating" @click="tabChanged('wageInfo', true)" >Back</vs-button>  -->
                                <vs-button color="dark" class="save" type="filled" :disabled="jdUpdating" @click="tabChanged('attornyOrAgentInfo', false)" >Next</vs-button>                                 
                                <vs-button v-if="false" color="success" :disabled="jdUpdating" @click="submitForm()" class="save" type="filled">Submit</vs-button>
                              
                               
                                <!-----
                                     <vs-button color="success" :disabled="jdUpdating" @click="submitForm()" class="save" type="filled">Submit</vs-button>
                                --->
                            </div>
                        </div>
                        <div v-if="activeTab=='attornyOrAgentInfo'">

                            <div class="modal_cnt withTabButtons attornyOrAgentInfo">
                                <form data-vv-scope="attornyOrAgentInfo" @submit.prevent="" @keydown.enter.prevent="" >
                                    <div class="form-container">
                                        <VuePerfectScrollbar  ref="mainSidebarPs"	  class="scroll-area--main-sidebar"	 :settings="settings"> 
                                            <div class="infoSec">
                                                <div calss="vx-row">
                                                    <div  class="vx-col w-full" >
                                                        <div class="list-radio-wrap">
                                                            <h6 class="d-flex">Indicate the type of representation for the employer in the filing of this application 
                                                            
                                                                <div v-if="false" class="IB_tooltip"  > <span><info-icon size="1.5x" class="custom-class"></info-icon></span>
                                                                    <div class="tooltip_cnt">
                                                                        <p>Indicate the type of representation for the employer in the filing of this application</p>
                                                                    </div>
                                                                </div>
                                                            </h6>
        
                                                                <ul class="list-radio" vs-type="flex" vs-align="center">
                                                                    <li @click="attornyOrAgentInfo.entityType='Attorney'" :class="{ 'active':attornyOrAgentInfo.entityType=='Attorney'}"> <span  >Attorney</span></li>
                                                                    <li @click="attornyOrAgentInfo.entityType='Agent'" :class="{ 'active':attornyOrAgentInfo.entityType=='Agent'}"> <span    >Agent</span></li>
                                                                    <li @click="attornyOrAgentInfo.entityType='None'" :class="{ 'active':attornyOrAgentInfo.entityType=='None'}"> <span >N/A</span></li>
                                                                </ul>
        
                                                            </div>
                                                            <div>
                                                            <template >
                                                            <input :name="'entityType'" v-validate="'required'" type="hidden" v-model="attornyOrAgentInfo.entityType"  >
                                                            <p v-show="errors.has('attornyOrAgentInfo.entityType')" class="text-danger text-sm">  <template >{{ errors.first('attornyOrAgentInfo.entityType') }}</template>  </p>
                                                            </template>
                                                         </div>
                                                     </div>
                                                     <div  class="vx-col w-full" v-if="checkProperty(attornyOrAgentInfo,'entityType') =='Attorney'" >
                                                        <!-- Attorny Details -->
                                                        <selectField :wrapclass="'md:w-1/2'" :required="true"   :formscope="'attornyOrAgentInfo'" :optionslist="users" v-model="attornyOrAgentInfo.attorneyDetails" @input="attornyOrAgentInfo.attorneyId = attornyOrAgentInfo.attorneyDetails['_id']"   fieldName="attorneyDetails" label="Select Attorney" placeHolder="Select Attorney "   />  
                                                        <!-- <immiInput :wrapclass="'md:w-1/2'"  :display="false" cid="attorneyFeiNumber" formscope="attornyOrAgentInfo" v-model="attornyOrAgentInfo.attorneyFeiNumber" :required="true"  :fieldName="'attorneyFeiNumber'" label="Business FEIN" placeHolder="Business FEIN"  :maxLength="9" :onlyNumbers="true"/> -->
                                                        <!-- <the-mask :wrapclass="'md:w-1/3'" autocomplete="off" autocorrect="off" name="feiNumber"
                                                         v-model="attornyOrAgentInfo.attorneyFeiNumber" class="vs-inputx vs-input--input full"
                                                         data-vv-as="Business FEIN" placeholder="##-#######"
                                                         :mask="['##-#######']" /> -->
                                                         <immiMask  :display="false" :tplkey="'attorneyFeiNumber'" :patren="['##-#######']" datatype="min:9|max:9" :wrapclass="'md:w-1/2'" cid="attorneyFeiNumber" formscope="attornyOrAgentInfo" v-model="attornyOrAgentInfo.attorneyFeiNumber" :tplsection="'attorneyFeiNumber'"  :fieldName="'attorneyFeiNumber'"  :required="true"  label="Business FEIN" vvas="Business FEIN" placeHolder="##-#######" />
                                                        
                                                    </div>
                                                </div>
                                                <div v-if="checkProperty(attornyOrAgentInfo,'entityType') =='Agent'">
                                                    <div class="vx-row">
                                                    <!-- Agent Info  -->
                                                    <div class="vx-col w-full">
                                                        <vx-input-group class="form-input-group FML">
                                                            <immiInput :display="true"  cid="benf" formscope="attornyOrAgentInfo" v-model="agentInfo.firstName" :required="true" :fieldName="'firstName'" label="First Name" placeHolder="First Name" />
                                                            <immiInput :display="true"  cid="benm" formscope="attornyOrAgentInfo" v-model="agentInfo.middleName"   :required="false" :fieldName="'middleName'" label="Middle Name" placeHolder="Middle Name" />
                                                            <immiInput :display="true" cid="benl" formscope="attornyOrAgentInfo" v-model="agentInfo.lastName"  :required="true" :fieldName="'lastName'" label="Last Name" placeHolder="Last Name" />
                                                        </vx-input-group>
                                                    </div>
                                                    <immiInput :wrapclass="'md:w-1/3'" :display="false"  datatype="email" cid="benfemail" formscope="attornyOrAgentInfo" v-model="agentInfo.email" :required="true"  :fieldName="'email'"  label="Email" placeHolder="Email" />
                                                    <immiPhone :wrapclass="'md:w-1/3'" :display="false" @updatephoneCountryCode="updatePhoneCountryCode" :countrycode="agentInfo.phoneCountryCode.countryCode" cid="phone" formscope="attornyOrAgentInfo" v-model="agentInfo.phone"  :fieldName="'phone'" :required="true" label="Phone Number" placeHolder="Phone Number" />
                                                    <immiInput :wrapclass="'md:w-1/3'" :display="false"  datatype="email" cid="busEmail" formscope="attornyOrAgentInfo" v-model="agentInfo.busEmail" :required="true"  :fieldName="'busEmail'"  label="Business Email" placeHolder="Business Email" />
                                                    <immiInput :wrapclass="'md:w-1/3'" :display="false"  cid="busName" formscope="attornyOrAgentInfo" v-model="agentInfo.busName" :required="true"  :fieldName="'busName'" label="Business Name" placeHolder="Business Name" />
                                                    <!-- <immiInput :wrapclass="'md:w-1/3'"  :display="false" cid="busEIN" formscope="attornyOrAgentInfo" v-model="agentInfo.busEIN" :required="true"  :fieldName="'busEIN'" label="Business FEIN" placeHolder="Business FEIN"  :maxLength="9" :onlyNumbers="true"/> -->
                                                    <immiMask  :display="false" :tplkey="'busEIN'" :patren="['##-#######']" datatype="min:9|max:9" :wrapclass="'md:w-1/3'" cid="busEIN" formscope="attornyOrAgentInfo" v-model="agentInfo.busEIN" :tplsection="'busEIN'"  :fieldName="'busEIN'"  :required="true"  label="Business FEIN" vvas="Business FEIN" placeHolder="##-#######" />
                                                    </div>
                                                    <div class="divider mt-0"></div>
                                                    <div class="vx-col w-full" v-if="countries.length>0"    vs-type="flex"  vs-justify="center" vs-align="center" vs-lg=" "  vs-sm=" "  >
                                                        <div class="addMoreAddress">
                                                        <h3 class="small-header mt-0">Address</h3>
                                                        <div class="vx-row mar0"   >
                                                                    <addressFields
                                                                        :formscope="'attornyOrAgentInfo'"
                                                                        :name="'agentInfo_address'"
                                                                        :disableCountry="false"
                                                                        :addFormContainerCls="false"
                                                                        :validationRequired="true"
                                                                        :showaptType="true"
                                                                        :countries="countries"
                                                                        v-model="agentInfo['address']"
                                                                        :cid="'agentInfo_address'"
                                                                    />
                                                                </div>
                                                        </div>    
                                                    </div>
                                                </div>

                                            </div>
                                        </VuePerfectScrollbar>
                                    </div>

                                </form>
                            </div>
                            <div class="popup-footer">
                                <span class="loader" v-if="jdUpdating"><img src="@/assets/images/main/loader.gif"></span>
                                <vs-button color="dark" class="cancel" type="filled" @click="hideMe()">Cancel</vs-button>
                                
                                <vs-button color="dark" class="save" type="filled" :disabled="jdUpdating" @click="tabChanged('jobOpptInfo', true)" >Back</vs-button>                                
                                <vs-button color="success"  :disabled="jdUpdating" @click="submitForm()" class="save" type="filled">Submit</vs-button>
                              
                               
                                <!-----
                                     <vs-button color="success" :disabled="jdUpdating" @click="submitForm()" class="save" type="filled">Submit</vs-button>
                                --->
                            </div>    
                        </div>
                        

                </div>

            </div>
                

            <vs-popup class="holamundo main-popup" title="Comments" :active.sync="jobSuggssionComments">
                <div class="form-container mt-6">
                <div class="vx-row">

                <div class="vx-col w-full">
                <!-- <vs-textarea v-model="comments" label="Comments…" class="w-full" /> -->
                <ckeditor  v-model="comments" label="Comments…" class="w-full"  :editor="editor" :config="editorConfig"></ckeditor>

                </div>
                </div>
                </div>
                <div class="popup-footer">
                    <span class="loader" v-if="jdUpdating"><img src="@/assets/images/main/loader.gif"></span>
                    <vs-button color="dark" class="cancel" type="filled" :disabled="jdUpdating" @click="tabChanged('wageInfo')" >Back</vs-button>
                    <vs-button color="success" :disabled="jdUpdating" @click="submitForm()" class="save" type="filled">Submit</vs-button>

                </div>
            </vs-popup>
           </div> 
   
</template>
<script>
  import immiPhone from "@/views/forms/fields/phonenumber.vue";
import Vue from "vue";
import immiswitchyesno from "@/views/forms/fields/switchyesno.vue";
import immiyesorno from "@/views/forms/fields/yesorno.vue";
import addressFields from "@/views/forms/fields/address.vue";
import immitextarea from "@/views/forms/fields/simpletextarea.vue";
import immitextfield from "@/views/forms/fields/simpleTextField.vue";
 import immiInput from "@/views/forms/fields/simpleinput.vue";
 import selectField from "@/views/forms/fields/simpleselect.vue";
 import datepickerField from "@/views/forms/fields/datepicker.vue";
 import VuePerfectScrollbar from "vue-perfect-scrollbar";
 import redioButtons from "@/views/forms/fields/redioButtons.vue";
import * as _ from "lodash";
import moment from "moment";
import { XIcon } from 'vue-feather-icons'
Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import JQuery from "jquery";
import { TheMask } from 'vue-the-mask'
import immiMask from "../../forms/fields/maskinput.vue";

export default {
    computed: {
        //getJobStartDate petitionDetails.applicationInfo.jobEndOn
        getJobStartDate(){
            if(this.petitionDetails['jobDetails'].applicationInfo.jobEndOn){
                try {
                    return moment(this.petitionDetails['jobDetails'].applicationInfo.jobEndOn).format("YYYY-MM-DD");
                }catch(err){
                    return new Date(); 
                }

            }else{
                return new Date();
            }

        }
        
    },
    provide() {
      return {
         parentValidator: this.$validator,
      };
  },
  created() {
    //this.$validator = this.parentValidator;
   },
    components: {
        immiPhone,
        addressFields,
        immitextarea,
        immitextfield,
        immiInput,
        selectField,
        datepickerField,
        XIcon,
       immiswitchyesno,
       immiyesorno,
       redioButtons,
       VuePerfectScrollbar,
       TheMask,
       immiMask
    },

    data() {
     return {
        "attornyOrAgentInfo": {
				"entityType": "Attorney", // Agent, Attorney, None 
				attorneyId: null,
                attorneyDetails:null,
                attorneyFeiNumber:null,
                			
				
			},
        "agentInfo": {
                "firstName": "",
                "middleName": "",
                "lastName": "",
                "name": "",
                "email": "",
                "phone": "",
                phoneCountryCode: {countryCode: '',countryCallingCode: ''},
                "address": {
                    "line1" : "",
                    "line2" : "",
                    "aptType": "",
                    "locationId" : null,
                    "stateId" : null,
                    "countryId" : null,
                    "zipcode" : null,
                    "locationDetails" : { "id" : null, "name" : "", "stateId" : null, "countryId" : null },
                    "stateDetails" : { "id" : null, "name" : null, "shortName" : "", "countryId" : null },
                    "countryDetails" : { "id" : null, "shortName" : "", "name" : "", "phoneCode" : 1, "order" : null, "currencySymbol" : "", "currencyCode" : "", "zipcodeLength" : null}
                },
                "busEmail": "",
                "busName": "",
                "busEIN": ""
            },
            users:[],
        
        moreJobDetails: {
            jobId: "",
            noOfPositions: "",
            salary: "",
            jobType: "",
            jobShift: "",
            hoursPerWeek: '',
            applicationInfo: {
                applyByMail: "",
                jobStartsOn: null,
                jobEndOn: null
            }
        },
        wageInfo: {
            trackingNumber: "",
            preferredSocCode: '',
            preferredWageRate: "",
            payFrequency: "", 
            wageSource: "", 
            wageSourceOtherDesc: "",
            determinationDate: null,
            expirationDate: null
        },
        wageOfferInfo: {
            minWage: "",
            maxWage: "",
            payFrequency: "" 
        },
        classificationList:['EB2','EB3','EB3S'],
        maxWaseError:'',
        completedtabs:[],
        editor: ClassicEditor,
        editorConfig: {
         toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
        },
        settings: {
   
          wheelSpeed: 0.6,
        },
        tempAddresses: {
                aptType:'',
                companyName: "",
                line1: "",
                line2: "",
                countryId: "",
                stateId: "",
                locationId: "",
                zipcode: "",
                countryDetails: null,
                stateDetails: null,
                locationDetails: null,
                workLocation:true
            },
        comments:'',
        jobSuggssionComments:false,
        valiedjobDetailsForm:false,
        valiedwageInfoFrorm:false,
        valiedjobOpptInfoForm:false,


        newSkill:'',
        addSkill:true,
        countries: [],
        permjobDetailsPopUp:true,
        //activeTab:'jobDetails',
        activeTab:'jobOpptInfo',
        
        educationTypes:[],
        masterSocList:[],
        wageSourceList:['OES', 'CBA', 'Employer Conducted', 'DBA', 'SCA', 'Other'],
        payFrequencyList:[ 'Bi-Weekly',"Hour","Week","Month","Year" ],
        jdUpdateStatusError:'',
        jdUpdating:false,
        errorMessage:'',
        toggleRequired:{
            ForeignLanguage:true,
            LicenseCertification:true,
            residencyFellowship:true,
            otherSplSkillsOrRequi:true
        },
     }
    },
    methods: {
        checkisRequirement(){
            if( this.checkProperty(this.petitionDetails ,'jobOpportunityInfo' ,'ForeignLanguage') ){
                this.toggleRequired = {
                    ForeignLanguage:true,
                    LicenseCertification:false,
                    residencyFellowship:false,
                    otherSplSkillsOrRequi:false
                }

            } else if( this.checkProperty(this.petitionDetails ,'jobOpportunityInfo' ,'LicenseCertification') ){
                this.toggleRequired = {
                    ForeignLanguage:false,
                    LicenseCertification:true,
                    residencyFellowship:false,
                    otherSplSkillsOrRequi:false
                }
                

            }else if( this.checkProperty(this.petitionDetails ,'jobOpportunityInfo' ,'otherSplSkillsOrRequi') ){
                this.toggleRequired = {
                    ForeignLanguage:false,
                    LicenseCertification:false,
                    residencyFellowship:false,
                    otherSplSkillsOrRequi:true
                }
                

            }else if( this.checkProperty(this.petitionDetails ,'jobOpportunityInfo' ,'residencyFellowship') ){
                this.toggleRequired = {
                    ForeignLanguage:false,
                    LicenseCertification:false,
                    residencyFellowship:true,
                    otherSplSkillsOrRequi:false
                }
            

            }else{
                this.toggleRequired = {
                    ForeignLanguage:true,
                    LicenseCertification:true,
                    residencyFellowship:true,
                    otherSplSkillsOrRequi:true
                }

            }



        },
        updatedSplSkillOrOtherRequi(){
            if(this.checkProperty(this.petitionDetails, 'jobOpportunityInfo','splSkillOrOtherRequi') !='Yes'){
               
                this.petitionDetails.jobOpportunityInfo['ForeignLanguage'] ="";
                this.petitionDetails.jobOpportunityInfo['LicenseCertification'] ="";
                this.petitionDetails.jobOpportunityInfo['residencyFellowship'] ="";
                this.petitionDetails.jobOpportunityInfo['otherSplSkillsOrRequi'] ="";
                this.toggleRequired = {
                    ForeignLanguage:true,
                    LicenseCertification:true,
                    residencyFellowship:true,
                    otherSplSkillsOrRequi:true
                }
            }

        },
        getUsersList(callFromSerch = false) {
            let matcher = {
                roleIds: [6],
                title: '',
                searchString: '',
                statusIds: [],
                stateIds: [],
                locationIds: [],
                createdDateRange: []
            };
            let query = {};
            query['page'] = 1;
            query['perpage'] = 500;
            query['matcher'] = matcher;
            //   query['sorting'] = this.sortKey;

            this.$store .dispatch("getList", { data: query, path: '/users/list' })
            .then(response => {
                let list = response.list;
                _.forEach(list, (ite)=>{
                    ite['id'] = ite['_id']
                })
                this.users = _.cloneDeep(response.list);
            }).catch((err) => {
            this.users = [];
            })
        },
        updatePhoneCountryCode(data){
            this.petition.beneficiaryInfo.cellPhoneCountryCode =data;
        },
        resetAgentInfo(){
            return {
                "firstName": "",
                "middleName": "",
                "lastName": "",
                "name": "",
                "email": "",
                "phone": "",
                phoneCountryCode: {countryCode: '',countryCallingCode: ''},
                "address": {
                    "line1" : "",
                    "line2" : "",
                    "aptType": "",
                    "locationId" : null,
                    "stateId" : null,
                    "countryId" : null,
                    "zipcode" : null,
                    "locationDetails" : { "id" : null, "name" : "", "stateId" : null, "countryId" : null },
                    "stateDetails" : { "id" : null, "name" : null, "shortName" : "", "countryId" : null },
                    "countryDetails" : { "id" : null, "shortName" : "", "name" : "", "phoneCode" : 1, "order" : null, "currencySymbol" : "", "currencyCode" : "", "zipcodeLength" : null}
                },
                "busEmail": "",
                "busName": "",
                "busEIN": ""
            }
        },
        minimumWageMethod(){
            let maxWagee = null
            let minWagee = null
            
            this.maxWaseError = '';
            if(this.petitionDetails.wageOfferInfo.maxWage){
                maxWagee = this.petitionDetails.wageOfferInfo.maxWage
            }
            if(this.petitionDetails.wageOfferInfo.minWage){
                minWagee = this.petitionDetails.wageOfferInfo.minWage
            }

            if(parseInt(minWagee) > parseInt(maxWagee)){
               
                this.petitionDetails.wageOfferInfo.maxWage = null;
                this.maxWaseError ='Maximum Wage is must be greater than or equal to Minimum Wage';
            }
        },
        maximumWageMethod(){
            let maxWagee = null
            let minWagee = null
            if(this.petitionDetails.wageOfferInfo.minWage){
                minWagee = this.petitionDetails.wageOfferInfo.minWage
            }
            if(this.petitionDetails.wageOfferInfo.maxWage){
                maxWagee = this.petitionDetails.wageOfferInfo.maxWage
            }
            if(parseInt(minWagee) > parseInt(maxWagee)){
                this.petitionDetails.wageOfferInfo.minWage = null
            }
        },
        updateHoursWeek(val){
            // if(val ){
            //     let item = parseInt(val)
            //     if(item > 168){
            //         this.$refs['updateHoursPerWeek'].updateErrorMsg(true, 'Hours should not be greater than 168')
            //         this.errorMessage = 'Hours should not be greater than 168';
            //         //this.petitionDetails['moreJobDetails'].hoursPerWeek = null;
            //     }else{
            //         this.$refs['updateHoursPerWeek'].updateErrorMsg(false, '')
            //         this.errorMessage = ''
            //     }
            // }
        },
        updateJobStartDate(val){
            if(val){
                let startDate = moment(val);
                if(this.petitionDetails['moreJobDetails'].applicationInfo.jobEndOn){
                    let endDate= moment(this.petitionDetails['moreJobDetails'].applicationInfo.jobEndOn)
                    if(startDate.isAfter(endDate , 'day')){
                        this.petitionDetails['moreJobDetails'].applicationInfo.jobEndOn = null
                    }
                }
            }else{
                this.petitionDetails['moreJobDetails'].applicationInfo.jobEndOn = null
            }
        },
        updateDeterminationDate(val){
            if(val){
                let startDate = moment(val);
                if(this.petitionDetails['wageInfo'].expirationDate){
                    let endDate= moment(this.petitionDetails['wageInfo'].expirationDate)
                    if(startDate.isAfter(endDate , 'day')){
                        this.petitionDetails['wageInfo'].expirationDate = null;
                    }
                }
            }else{
                this.petitionDetails['wageInfo'].expirationDate = null;
            }
        },
        setWorkLocation(indexx){
            setTimeout(()=>{
                _.map(this.petitionDetails['jobOpportunityInfo']['workAddresses'] , (item ,ind)=>{
                if(ind != indexx){
                    item.workLocation =false;
                }
                })
            });
        },
        getComments(){
            this.$validator.validateAll(this.activeTab).then((result) => {
                this.jobSuggssionComments = true;
            })

        },

        tabChanged(tab='jobOpptInfo',back = false){
            let currentTab = _.cloneDeep(this.activeTab);
            //this.activeTab = tab;
            this.maxWaseError='';
           // let tablist = ['jobDetails', 'wageInfo', 'jobOpptInfo', 'attornyOrAgentInfo']
            let tablist = ['jobOpptInfo', 'attornyOrAgentInfo']
            let changedBackTab = false;
            let currentTabIndex = tablist.indexOf(currentTab);
            let changingTabIndex = tablist.indexOf(tab);
            // if( currentTabIndex && changingTabIndex && (parseInt(changingTabIndex) < parseInt(currentTabIndex)) ){
            //     changedBackTab = true; 
            // }
            if( changingTabIndex  < currentTabIndex ){
                changedBackTab = true;
            }
           // maximumWageMethod(); minimumWageMethod();tabChanged('wageInfo') this.completedtabs.indexOf(tab) > -1
           if(tab =='wageInfo'){
            
            this.minimumWageMethod();
            //this.maximumWageMethod(); 
            

           }
           
            this.$validator.validateAll(this.activeTab).then((result) => {
                if((result && this.errorMessage == '') || (back && this.errorMessage == '') || changedBackTab ){
                    
                    if(result)  {
                        if (this.completedtabs.includes(currentTab)) {
                            
                        } else {
                            this.completedtabs.push(currentTab)
                        }
                        
                    }
                   this.activeTab = tab;

                }else{
                    this.completedtabs = _.filter(this.completedtabs,(tbl)=>{
                        return currentTab !=tbl
                    });
                    const $ = JQuery;

                    if($('.text-danger:visible')){
                        $('.withTabButtons').scrollTop($('.text-danger:visible').first().parent().offset().top-50);
                     }
      
                }

        })
            // if(!this.jdUpdating){
            //     this.activeTab = tab;
            // }
            this.jdUpdateStatusError ='';
            
        },
        
        submitForm() {
        this.jdUpdateStatusError='';
        this.minimumWageMethod();
        this.$validator.validateAll(this.activeTab).then((result) => {
           if(result && !this.filesAreuploading && this.maxWaseError ==''){
            this.jdUpdating =true;
            let path ="/perm/update-job-description-for-efile";
            let data = {
                "petitionId": "",
                "userName": "",
                //"action": "", // 'CREATE_JOB_DESC','REQUEST_JOB_DESC_REVIEW', 'JOB_DESC_SUGGESSION', 'APPROVE_JOB_DESC', 'FINALIZE_JOB_DESC'
                //"jobDescSuggessionType": "comments", //job_desc_update // Required for 'JOB_DESC_SUGGESSION'
                //"comment": "", // Requied for jobDescSuggessionType = 'comments' 
                "typeName": "",
                "subTypeName": "",
                //jobDetails:{},
                wageInfo:{},
                wageOfferInfo:{},
                moreJobDetails:{},
                attornyOrAgentInfo:{

                    "entityType": "Attorney", // Agent, Attorney, None
				    attorneyId: null,
                    agentInfo:{},
                    attorneyFeiNumber:null,
                    
                }
                
            }
            data['attornyOrAgentInfo']['agentInfo'] = this.resetAgentInfo();

            // if(this.ACTIVITYCODE=='JOB_DESC_SUGGESSION'){
            //     data['jobDescSuggessionType'] = 'job_desc_update'; attornyOrAgentInfo['attorneyDetails']
            // }
            data['attornyOrAgentInfo']['attorneyId'] = this.checkProperty(this.attornyOrAgentInfo,'attorneyId');
            data['attornyOrAgentInfo']['entityType'] = this.checkProperty(this.attornyOrAgentInfo,'entityType');

            if(this.checkProperty(this.attornyOrAgentInfo,'entityType') =='Attorney'){
                data['attornyOrAgentInfo']['agentInfo']= this.resetAgentInfo(); 
                data['attornyOrAgentInfo']['attorneyId'] = this.checkProperty(this.attornyOrAgentInfo,'attorneyDetails', '_id');
                data['attornyOrAgentInfo']['attorneyFeiNumber'] = this.checkProperty(this.attornyOrAgentInfo,'attorneyFeiNumber');

            } else if(this.checkProperty(this.attornyOrAgentInfo,'entityType') =='Agent'){
                data['attornyOrAgentInfo']['attorneyId'] =null;
                data['attornyOrAgentInfo']['attorneyFeiNumber'] =null;
                data['attornyOrAgentInfo']['agentInfo'] = this.agentInfo;

            }

            data['petitionId'] = this.checkProperty( this.petitionDetails ,'_id');
            data['userName'] = this.checkProperty( this.getUserData , 'loginRoleName');
            // data['action']  = this.ACTIVITYCODE; 
            //data['action']  = 'JOB_DESC_SUGGESSION'; 
            data['typeName'] = this.checkProperty( this.petitionDetails , 'typeDetails','name');
            data['subTypeName'] = this.checkProperty( this.petitionDetails ,'subTypeDetails','name');              
            //data['jobDetails'] = this.checkProperty( this.petitionDetails , 'jobDetails');
            data['wageInfo'] = this.checkProperty( this.petitionDetails , 'wageInfo');
            data['wageOfferInfo'] = this.checkProperty( this.petitionDetails , 'wageOfferInfo');
            data['moreJobDetails'] = this.checkProperty( this.petitionDetails , 'moreJobDetails');  
            data['jobOpportunityInfo'] = this.checkProperty( this.petitionDetails , 'jobOpportunityInfo'); 
            if(this.loadedFromPwdLibrary){
                path = "/pwd/update-job-description-for-efile";
                data['pwdId'] = this.checkProperty( this.petitionDetails ,'_id');

                if(this.checkProperty( this.petitionDetails ,'petitionList' ,'length')==1 && this.petitionDetails['completedActivities'].indexOf('PWD_CERTIFID')<=-1 ){
                    path ="/perm/update-job-description-for-efile";
                    data["typeName"] ="GC-Employment";
                    data["subTypeName"] ="GC-Employment";
                    data['petitionId'] = this.petitionDetails['petitionList'][0]['_id'];
                }
            }
            this.$store.dispatch('commonAction' ,{ "data":data ,'path':path})
            .then((res)=>{
              this.showToster({message:res['message'],isError:false });
              this.hideMe();
              this.$emit("updatepetition");

                const existingButton = document.getElementById('submit-efill')
                if (existingButton) {
                    existingButton.click()
                } else {
                    this.$emit("openDownloadAppPopup");
                }

            //  // window.open("https://flag.dol.gov/auth/auth/login-gov/login/loa-1");

            //   let efilePath = "https://flag.dol.gov/dashboard";
            //     if(this.checkProperty(this.petitionDetails,'dolEfilePermRefId')){
            //         //dolEfilePermRefId
            //         efilePath = "https://flag.dol.gov/dashboard/application/9141/"+this.petitionDetails['dolEfilePermRefId'];
            //     }
            //  //window.open("https://www.plc.doleta.gov/eta_start.cfm?actiontype=home");
            //   window.open(efilePath);
              
            })
            .catch((error)=>{
              this.jdUpdateStatusError =error;
              this.jdUpdating =false;
             })
           }
            else{
                const $ = JQuery;
                if($('.text-danger:visible')){
                    $('.withTabButtons').scrollTop($('.text-danger:visible').first().parent().offset().top-50);
                }
            }
        });
       },
        addNewSkill(callFrom=''){
            if(this.newSkill && this.newSkill.trim() !=''){
                let skil = this.newSkill.trim();
                if(callFrom=='jobOpportunityInfo'){
                    if(this.petitionDetails['jobOpportunityInfo']['skills'].indexOf(skil) <=-1){
                        this.petitionDetails['jobOpportunityInfo']['skills'].push(skil);
                    }

                }else{
                    if(this.petitionDetails['jobDetails']['skills'].indexOf(skil) <=-1){
                        this.petitionDetails['jobDetails']['skills'].push(skil);
                    }
               }
                
                this.newSkill ='';
                this.addSkill =false;
            }
           

        },
        removeSkill(index, callFrom=''){
            
            if(callFrom=='jobOpportunityInfo'){
                this.petitionDetails['jobOpportunityInfo']['skills'].splice(index ,1);
            }else{
                this.petitionDetails['jobDetails']['skills'].splice(index ,1);

            }
            
        },

        updateisForiegnLangRequired(){
            if(this.checkProperty(this.petitionDetails ,'jobOpportunityInfo','isForiegnLangRequired') !='Yes'){
               
               this.petitionDetails['jobOpportunityInfo']['skills'] =[];
              
               
           }

        },
        updateisExpInAltOccuAccept(){
            
            if(this.checkProperty(this.petitionDetails ,'jobOpportunityInfo','isExpInAltOccuAccept') !='Yes'){
               
                this.petitionDetails['jobOpportunityInfo']['noOfExpMonthsInAltOccu'] =null;
                this.petitionDetails['jobOpportunityInfo']['jobTitleOfAcceptAltOccu'] ='';
                
            }

        },
        updateisAltCombOfEduAndExpAccept(){
            
            if(this.checkProperty(this.petitionDetails ,'jobOpportunityInfo','isAltCombOfEduAndExpAccept') !='Yes'){
               
                this.petitionDetails['jobOpportunityInfo']['altLevelOfEdu'] =null;
                this.petitionDetails['jobOpportunityInfo']['altAcceptExpInYears'] ='';
                
            }

        },
        updateisAltFieldOfStudyAccept(){
            
            if(this.checkProperty(this.petitionDetails ,'jobOpportunityInfo','isAltFieldOfStudyAccept') !='Yes'){
               
                this.petitionDetails['jobOpportunityInfo']['altMajorFieldOfStudy'] ='';
            }

        },
        
        updateisExpRequired(){
            
            if(this.checkProperty(this.petitionDetails ,'jobOpportunityInfo','isExpRequired') !='Yes'){
               
                this.petitionDetails['jobOpportunityInfo']['noOfExpMonths'] =null;
                this.petitionDetails['jobOpportunityInfo']['expReqOccupation'] ='';
                
            }

        },
        updateIsTrainigRequired(){
            
            if(this.checkProperty(this.petitionDetails ,'jobOpportunityInfo','isTrainigRequired') !='Yes'){
               
                this.petitionDetails['jobOpportunityInfo']['noOfTraningMonths'] =null;
                this.petitionDetails['jobOpportunityInfo']['fieldOfTraining'] ='';
                
            }

        },
        addAddress(){

            let newAddress = {
                "companyName": "",
                "workLocation": false,
                line1: "",
                line2: "",
                zipcode: "",
                countryId: "231",
                stateId: "",
                locationId: "",
                "countryDetails": { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
                stateDetails: null,
                locationDetails: null,
                aptType:''
            };
            this.petitionDetails['jobOpportunityInfo']['workAddresses'].push(newAddress);
            //this.$validator.reset();

        },
        removeAddress(index){
            this.petitionDetails['jobOpportunityInfo']['workAddresses'].splice(index ,1);

        },
        hideMe(){
            this.$validator.reset();
            this.permjobDetailsPopUp =false;
            this.$emit('hideMe');

        },
        getMasterSocList(){

        let query = {};
        query["page"] = 1;
        query["perpage"] = 10000;
        query["matcher"] = { 
            // "getInactiveListAlso": true
             };
        query["category"] = "soc_codes";
       

        this.$store
        .dispatch("getMasterData", query)
        .then((response) => {
            this.masterSocList = response.list;
            if(this.checkProperty(this.petitionDetails ,'wageInfo' ,'socCode' )){
                this.petitionDetails['wageInfo']['socCodeDetails'] = _.find(this.masterSocList, {"id": this.petitionDetails['wageInfo']['socCode']});
            }


        //alert(this.perpage);
        })
        .catch(() => {
        this.masterSocList = [];

        });

       },
       
        updateMainDegree(item){ 

            if(_.has( item ,'id')){
                this.petitionDetails['jobDetails']['minDegree'] = item['id'];
            }
        },
      
        jobOppupdateMainDegree(item){
            
            if(_.has( item ,'id')){
                this.petitionDetails['jobOpportunityInfo']['minDegree'] = item['id'];
            }
        },
        updatesocCode(item){ 

            if(_.has( item ,'id')){
            this.petitionDetails['wageInfo']['socCode'] = item['id'];
            }
        },

        //petitionDetails.jobOpportunityInfo.altLevelOfEdu
        //petitionDetails['jobOpportunityInfo'].minDegreeDetails
        getEducationList(){
            this.$store
                .dispatch("getmasterdata", "education_types")
                .then((response) => {
                    this.educationTypes = response;
                    /*
                    petitionDetails['jobDetails'].minDegreeDetails =this.petitionDetails['jobDetails']['minDegree']
                    petitionDetails.jobOpportunityInfo.altLevelOfEduDetails ===== petitionDetails.jobOpportunityInfo.altLevelOfEdu
                    petitionDetails['jobOpportunityInfo'].minDegreeDetails === this.petitionDetails['jobOpportunityInfo']['minDegree']
                    */
                  
                    

                   if(this.checkProperty(this.petitionDetails ,'jobDetails' ,'minDegree' )){
                     this.petitionDetails['jobDetails'].minDegreeDetails = _.find(this.educationTypes ,{'id':this.petitionDetails['jobDetails']['minDegree']});
                   }

                   if(this.checkProperty(this.petitionDetails ,'jobOpportunityInfo' ,'minDegree' )){
                     this.petitionDetails.jobOpportunityInfo.minDegreeDetails = _.find(this.educationTypes ,{'id':this.petitionDetails['jobOpportunityInfo']['minDegree']});
                   }

                   if(this.checkProperty(this.petitionDetails ,'jobOpportunityInfo' ,'altLevelOfEdu' )){
                     this.petitionDetails.jobOpportunityInfo.altLevelOfEduDetails = _.find(this.educationTypes ,{'id':this.petitionDetails['jobOpportunityInfo']['altLevelOfEdu']});
                   }

                });

        },
        getJobOppurtunityInfo(){
            let jobOpportunityInfo = {
                workAddresses: [
                {
                "companyName": "",
                "workLocation": true,
                line1: "",
                line2: "",
                zipcode: "",
                countryId: "231",
                stateId: "",
                locationId: "",
                "countryDetails": { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
                stateDetails: null,
                locationDetails: null,
                aptType:''
            }
                ],
                jobTitle: '',
                minDegree: null,
                majorFieldsOfStudy: null,
                isTrainigRequired: 'No', // Yes/No // Is training required for the job opportunity?
                noOfTraningMonths: null, //  If Yes, number of months of training required
                fieldOfTraining: '', // Indicate the field of training:
                isExpRequired: 'No', // Yes/No // Is experience in the job offered required for the job?
                noOfExpMonths: null, //  If Yes, number of months experience required
                expReqOccupation :null, //Indicate the occupation required
                isAltFieldOfStudyAccept: 'No', // Yes/No // Is there an alternate field of study that is acceptable?
                altMajorFieldOfStudy: '', //  If Yes, specify the major field of study
                isAltCombOfEduAndExpAccept: 'No', // Yes/No // Is there an alternate combination of education and experience that is acceptable
                altLevelOfEdu: null, // If Yes, specify the alternate level of education required
                altAcceptExpInYears: null, // If applicable, indicate the number of years experience acceptable
                foreignEduEqAccept: 'No', // Yes/No // Is a foreign educational equivalent acceptable?
                isExpInAltOccuAccept: 'No', // Yes/No // Is experience in an alternate occupation acceptable?
                noOfExpMonthsInAltOccu: null, // If Yes, number of months experience in alternate occupation required
                jobTitleOfAcceptAltOccu: '', // Identify the job title of the acceptable alternate occupation
                jobDuties: '', // Job duties – If submitting by mail, add attachment if necessary. Job duties description must begin in this space
                jobOppoReqForNormalOccu: 'No', // Yes/No // Are the job opportunity’s requirements normal for the occupation?
                isForiegnLangRequired: 'No', // Yes/No // Is knowledge of a foreign language required to perform the job duties?
                skills: [], // Specific skills or other requirements – If submitting by mail, add attachment if necessary. Skills description must begin in this space. 
                isApplInvolJobOppoInclCombOfOccu: 'No', // Yes/No // Does this application involve a job opportunity that includes a combination of occupations?
                positionOfferToAlien: 'No', // Yes/No // Is the position identified in this application being offered to the alien identified in Section J?
                alienReqToLiveEmplrPrimisis: 'No', // Yes/No //  Does the job require the alien to live on the employer’s premises?
                applLiveInHouseDomWorker: 'No', // Yes/No // Is the application for a live-in household domestic service worker?
                emplrProviedAlienCopyOfContract: 'NA' // Yes/No/NA // If Yes, have the employer and the alien executed the required employment contract and has the employer provided a copy of the contract to the alien?
                
            }
            return jobOpportunityInfo;
        }

    },
    props: {
        ACTIVITYCODE: {
            type: String,
            default: null,
        },
        value: null,
        formscope:{
            type:String,
            default:''

        },

        petitionDetails: {
            type: Object,
             default: null,
        },
        loadedFromPwdLibrary:{
      type: Boolean,
      default: false,

    },

    },
    mounted(){
        this.getUsersList();
        if(!_.has(this.petitionDetails,'moreJobDetails')){
            this.petitionDetails = Object.assign(this.petitionDetails,{'moreJobDetails':this.moreJobDetails})
        }
        if(!_.has(this.petitionDetails,'wageInfo')){
            this.petitionDetails = Object.assign(this.petitionDetails,{'wageInfo':this.wageInfo})
        }
        if(!_.has(this.petitionDetails,'wageOfferInfo')){
            this.petitionDetails = Object.assign(this.petitionDetails,{'wageOfferInfo':this.wageOfferInfo})
        }
        if(!_.has(this.petitionDetails,'attornyOrAgentInfo')){
            this.petitionDetails = Object.assign(this.petitionDetails,{'attornyOrAgentInfo':this.attornyOrAgentInfo})
        }
        if(!_.has(this.petitionDetails,'jobOpportunityInfo')){
            this.petitionDetails = Object.assign(this.petitionDetails,{'jobOpportunityInfo':this.getJobOppurtunityInfo()})
        }
        this.attornyOrAgentInfo['attorneyFeiNumber']=this.getTenantFien
        this.getMasterSocList()
       // this.activeTab = 'jobDetails';
        this.activeTab = 'jobOpptInfo';
        
        this.$store
            .dispatch("getmasterdata", "education_types")
            .then((response) => {
                this.educationTypes = response;
                // this.upDatehighestDegree();
            });
        this.$store.dispatch("getcountries").then(response => {
        this.countries = response;
        });


    }

}

</script>